import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { ICON_STROKE_WIDTH } from '../../constants';

interface CriticalResultsRefreshBannerProps {
  message: string | null;
  onRetry?: () => void;
}

export default function CriticalResultsRefreshBanner({
  message,
  onRetry,
}: Readonly<CriticalResultsRefreshBannerProps>) {
  if (!message) {
    return null;
  }

  return (
    <output className="crd-refresh-warning">
      <AlertTriangle
        size={16}
        strokeWidth={ICON_STROKE_WIDTH}
        aria-hidden
      />
      <span>{message}</span>
      {onRetry ? (
        <button
          type="button"
          className="crd-refresh-warning__retry"
          onClick={onRetry}
        >
          Retry now
        </button>
      ) : null}
    </output>
  );
}
